import { useState } from 'react';
import PropTypes from 'prop-types';
// mui
import { List } from '@mui/material';
// hooks
import useAuth from 'src/hooks/useAuth';
//redux
import { useDispatch } from 'src/redux/store';
import { getChatsAtendimento, getChatsGeral, getChatsPendente, getCountsChats, removeChatFromList, updateChatList } from 'src/redux/slices/chat';
//actions
import getActionAceitarChat from 'src/actions/chats/getActionAceitarChat';
import getActionChatByChatId from 'src/actions/chats/getActionChatByChatId';
//itens
import ChatAtendimentoItem from '../ChatsListItem/ChatAtendimentoItem';

ChatConversationListPendente.propTypes = {
  isOpenSidebar: PropTypes.bool
};

export default function ChatConversationListPendente({ chats, isOpenSidebar, ...other }) {
  const dispatch = useDispatch();
  const { user } = useAuth()
  const [loading, setLoading] = useState(false);


  const handleAceitar = async (chat) => {
    const { _id } = chat
    setLoading(true);
    try {
      const res_chat = await getActionChatByChatId({ chatId: _id });
      if (res_chat.data.statusRoom !== 'Atendendo') {
        dispatch(removeChatFromList({ chatId: _id, status: 'Pendente' }));
        getActionAceitarChat({ chatId: _id, usuarioId: user.id });

        let dataToUpdade = {
          _id: chat._id,
          scope: {
            novaMensagem: 'sim',
            statusRoom: 'Atendendo',
            direciona_usuarios: [user.id],
            direciona_setores: [],
            lastUpdate: new Date()
          }
        };
        dispatch(updateChatList(dataToUpdade)); // Atualiza a lista de chats



        // dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
        //dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, true));

        setLoading(false);
      }
    } catch (error) {
      console.log(error)
      setLoading(false);
    }

  };

  return (
    <List disablePadding {...other}>
      {chats.map((chat) => (
        <ChatAtendimentoItem
          key={chat._id}
          chat={chat}
          loading={loading}
          isOpenSidebar={isOpenSidebar}
          onSelectConversation={() => { }}
          onAceitarChat={() => handleAceitar(chat)}
        />
      ))}
    </List>
  );
}
